import './App.css';
import Header from './components/Header';
import Namaste from './components/Namaste';

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Inicio from './components/Inicio';
import ScrollToTop from './components/ScrollToTop';
import Casazen from './components/Casazen';
import Lasoñada from './components/Lasoñada';



function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Inicio />} />      
          <Route path="/namaste" element={<Namaste />} />
          <Route path="/casazen" element={<Casazen />} />
          <Route path="/lasonada" element={<Lasoñada />} />
        </Routes>
        <p className='footerCopy'>Jardines de Mar © 2022</p>

      </BrowserRouter>
    </div>
  );
}

export default App;
